import {
  createLocalStorageWithTTL,
  TTL,
} from '@/utils/storage/localStorage-with-ttl';

// The clicked promotion is remembered for 24 hours so it can be attached at
// item level to `view_item`, `add_to_cart`, `begin_checkout` and `purchase` for
// products reached from the landing list the banner opened.
const STORAGE_KEY = 'gtm_promotion_attribution';

const storage = createLocalStorageWithTTL(
  'gtm-promotion-attribution',
  TTL.ONE_DAY
);

export const storePromotionAttribution = (promotion, destination) => {
  if (!promotion?.promotion_id) return;

  storage.setItem(STORAGE_KEY, {
    promotion_id: promotion?.promotion_id,
    ...(promotion?.promotion_name && {
      promotion_name: promotion?.promotion_name,
    }),
    ...(destination && { path: new URL(destination).pathname }),
  });
};

// The promotion only while the shopper is on its landing page.
export const getPromotionAttribution = () => {
  const { path, ...promotion } = storage.getItem(STORAGE_KEY) || {};
  if (!path || typeof window !== 'object') return undefined;
  return window.location.pathname === path ? promotion : undefined;
};

export const clearPromotionAttribution = () => storage.removeItem(STORAGE_KEY);
